import { useDispatch } from "react-redux"
import Box from "../../../../components/Box"
import CustomNumberInput from "../../../../components/CustomNumberInput"
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect"
import CustomSwitch from "../../../../components/CustomSwitch"
import { storeFastFirm } from "../../../../redux/reducers/authSlice"
import { CompanyService } from "../../../../services/CompanyService"
import { ConstantService } from "../../../../services/ConstantService"
import { KTCard } from "../../../../_metronic/helpers/components/KTCard"
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody"

interface Props {
    transferInformationRef: any
    selectedTransferFirm: CustomSingleSelectModel | undefined
    setSelectedTransferFirm: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    transferAntrepoDeclarationNo: string | undefined
    setTransferAntrepoDeclarationNo: React.Dispatch<React.SetStateAction<string | undefined>>
    transferAntrepoDeclarationDate: string | undefined
    setTransferAntrepoDeclarationDate: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedDutyFirm: CustomSingleSelectModel | undefined
    setSelectedDutyFirm: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    transferWithExpenses: boolean
    setTransferWithExpenses: React.Dispatch<React.SetStateAction<boolean>>
    justTransfer: boolean
    setJustTransfer: React.Dispatch<React.SetStateAction<boolean>>
    goodsAmount: string | undefined
    setGoodsAmount: React.Dispatch<React.SetStateAction<string | undefined>>
    declarationPotQuantity: string | undefined
    setDeclarationPotQuantity: React.Dispatch<React.SetStateAction<string | undefined>>
    declarationPotWeight: string | undefined
    setDeclarationPotWeight: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedGoodsAmountCurrencyType: CustomSingleSelectModel | undefined
    setSelectedGoodsAmountCurrencyType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    guaranteeAmount: string | undefined
    setGuaranteeAmount: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedGuaranteeAmountCurrencyType: CustomSingleSelectModel | undefined
    setSelectedGuaranteeAmountCurrencyType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    isPartial: boolean
}

const TransferInformation = ({
    transferInformationRef,
    selectedTransferFirm,
    setSelectedTransferFirm,
    setTransferAntrepoDeclarationDate,
    setTransferAntrepoDeclarationNo,
    transferAntrepoDeclarationDate,
    transferAntrepoDeclarationNo,
    selectedDutyFirm,
    setSelectedDutyFirm,
    transferWithExpenses,
    setTransferWithExpenses,
    justTransfer,
    setJustTransfer,
    declarationPotQuantity,
    goodsAmount,
    setDeclarationPotQuantity,
    setGoodsAmount,
    declarationPotWeight,
    setDeclarationPotWeight,
    selectedGoodsAmountCurrencyType,
    setSelectedGoodsAmountCurrencyType,
    guaranteeAmount,
    setGuaranteeAmount,
    selectedGuaranteeAmountCurrencyType,
    setSelectedGuaranteeAmountCurrencyType,
    isPartial
}: Props) => {
    const dispatch = useDispatch();

    return (
        <div className='containerPart' ref={transferInformationRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Devir Bilgileri</h4>

                    <div className="row">
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Masraflarla Devir</label>
                            <CustomSwitch isActive={transferWithExpenses} setIsActive={() => {
                                setTransferWithExpenses(!transferWithExpenses);
                                setJustTransfer(false);
                            }} />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Sadece Devir</label>
                            <CustomSwitch isActive={justTransfer} setIsActive={() => {
                                setJustTransfer(!justTransfer);
                                setTransferWithExpenses(false);
                            }} />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Devredilen Firma</label>
                            <CustomSingleSelect
                                selectedValue={selectedTransferFirm}
                                onChange={setSelectedTransferFirm}
                                insertable={{
                                    tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                    onClick: () => {
                                        dispatch(storeFastFirm({
                                            companyId: selectedTransferFirm?.value,
                                            isCustomer: true,
                                            onSubmit: async (response) => {
                                                setSelectedTransferFirm({ label: response.name, value: response.companyId })
                                            },
                                        }))
                                    }
                                }}
                                onMenuOpen={[
                                    () => CompanyService.getCompanyList({ isCustomer: true }),
                                ]}
                                labelName='name'
                                valueName='companyId'
                            />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Beyan Kap Adet</label>
                            <CustomNumberInput isDisabled={!isPartial} value={declarationPotQuantity} setValue={setDeclarationPotQuantity} />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Devir Antrepo Beyan Tarihi</label>
                            <input style={{ border: '1px solid #F1F1F4' }} value={transferAntrepoDeclarationDate} onChange={(e) => setTransferAntrepoDeclarationDate(e.target.value)} type="datetime-local" className="form-control form-control-solid" />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Gümrük Firması</label>

                            <CustomSingleSelect
                                selectedValue={selectedDutyFirm}
                                onChange={setSelectedDutyFirm}
                                insertable={{
                                    tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                    onClick: () => {
                                        dispatch(storeFastFirm({
                                            companyId: selectedDutyFirm?.value,
                                            isDutyFirm: true,
                                            onSubmit: async (response) => {
                                                setSelectedDutyFirm({ label: response.name, value: response.companyId })
                                            },
                                        }))
                                    }
                                }}
                                onMenuOpen={() => CompanyService.getCompanyList({ isDutyFirm: true })}
                                labelName='name'
                                valueName='companyId'
                            />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Beyan Kap Ağırlık (Kg)</label>
                            <CustomNumberInput isDisabled={!isPartial} tabIndex={5} value={declarationPotWeight} setValue={setDeclarationPotWeight} />
                        </div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Mal Değeri</label>

                            <Box flexDirection="row">
                                <Box mr="15px" flexGrow={1} justifyContent="center">
                                    <CustomNumberInput isDisabled={!isPartial} value={goodsAmount} setValue={setGoodsAmount} />
                                </Box>
                                <Box justifyContent="center">
                                    <CustomSingleSelect
                                        disabled
                                        selectedValue={selectedGoodsAmountCurrencyType}
                                        onChange={setSelectedGoodsAmountCurrencyType}
                                        onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                        labelName='additionalValue1'
                                        valueName='constantId'
                                    />
                                </Box>
                            </Box>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Devir Antrepo Beyan No</label>
                            <input style={{ border: '1px solid #F1F1F4' }} value={transferAntrepoDeclarationNo} onChange={(e) => setTransferAntrepoDeclarationNo(e.target.value)} type="text" className="form-control form-control-solid" />
                        </div>

                        <div className="col-md-4">&nbsp;</div>

                        <div className="col-md-4">
                            <label htmlFor="exampleFormControlInput1" className="form-label required">Teminat Bedeli</label>

                            <Box flexDirection="row">
                                <Box mr="15px" flexGrow={1} justifyContent="center">
                                    <CustomNumberInput isDisabled={!isPartial} value={guaranteeAmount} setValue={setGuaranteeAmount} />
                                </Box>
                                <Box justifyContent="center">
                                    <CustomSingleSelect
                                        disabled
                                        selectedValue={selectedGuaranteeAmountCurrencyType}
                                        onChange={setSelectedGuaranteeAmountCurrencyType}
                                        onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                        labelName='additionalValue1'
                                        valueName='constantId'
                                    />
                                </Box>
                            </Box>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div >
    )
}

export default TransferInformation;